import { render, staticRenderFns } from "./EditDialog_Customs.vue?vue&type=template&id=5b5ea86b"
import script from "./EditDialog_Customs.vue?vue&type=script&lang=js"
export * from "./EditDialog_Customs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports